module.exports = __webpack_public_path__ + "static/img/copper.ca7a9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copper.png
// module id = wJSD
// module chunks = 1